import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetCurrent = (
  resourceName,
  version = 2,
  optionsOrResponseProcessor = {}
) => {
  const isResponseProcessor = typeof optionsOrResponseProcessor === 'function'
  const options = isResponseProcessor ? {} : optionsOrResponseProcessor

  const endpoint = isResponseProcessor
    ? async (client) => {
      const response = await client.get(`/${resourceName}`)
      return optionsOrResponseProcessor(response)
    }
    : `/${resourceName}`

  const query = useApiQuery(
    ['current', resourceName, version],
    'schools',
    endpoint,
    options,
    { authenticated: true, version }
  )

  return {
    isLoadingCurrent: query.isLoading,
    isFetchingCurrent: query.isFetching,
    currentData: query.data ?? [],
    errorCurrent: query.isError ? query.error : null,
    getCurrent: query.refetch
  }
}
